import { useEffect, useState } from "react";
import { Loader2, CalendarDays } from "lucide-react";
import { staffApi, fmtDate, fmtErr } from "../api";

const Holidays = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await staffApi.get("/holidays");
        setRows(Array.isArray(data) ? data.slice().sort((a, b) => a.date.localeCompare(b.date)) : []);
      } catch (e) {
        setError(fmtErr(e));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  return (
    <div data-testid="staff-holidays">
      <h1 className="font-display text-2xl font-bold text-slate-900">Holidays</h1>
      <p className="mt-1 text-sm text-slate-500">Company holiday calendar.</p>
      {loading ? (
        <p className="mt-10 flex items-center gap-2 text-sm text-slate-500"><Loader2 size={16} className="animate-spin" /> Loading…</p>
      ) : error ? (
        <p className="mt-6 text-xs text-[#C5221F] bg-red-50 border border-red-200 px-3 py-2.5 rounded-sm" data-testid="holidays-error">{error}</p>
      ) : rows.length === 0 ? (
        <p className="mt-6 text-sm text-slate-500 bg-white border border-slate-200 p-6" data-testid="holidays-empty">No holidays listed.</p>
      ) : (
        <ul className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="holidays-list">
          {rows.map((h) => {
            const past = h.date < todayStr;
            return (
              <li key={h.id} className={`bg-white border border-slate-200 p-5 flex items-start gap-4 ${past ? "opacity-50" : ""}`} data-testid={`holiday-row-${h.id}`}>
                <span className="w-10 h-10 shrink-0 bg-[#0A1128] text-white flex items-center justify-center">
                  <CalendarDays size={16} className="text-[#E8574F]" />
                </span>
                <span>
                  <span className="block font-display text-sm font-bold text-slate-900">{h.name}</span>
                  <span className="block mt-1 text-xs text-slate-500">{fmtDate(h.date)}{past ? " · past" : ""}</span>
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default Holidays;
